The role of the attachment within a profile.

Currently, three codes are defined:

- `CoverLetter` is used for a candidate's cover letter for a specific position.
- `Resume` is used for a candidate's resume or CV.
- `SelectionCriteria` is used for a candidate's selection criteria for a specific position.

Additional documents will have a `null` role code.
They can be distinguished by their free text `descriptions`.
